/* eslint-disable max-len */
import React from 'react';
import { CContainer, CRow, CCol, CCard, CCardBody, CCardHeader, CBreadcrumb, CBreadcrumbItem } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import MaterialInputs from '../../components/MaterialInputs/MaterialInputs';
import { connect } from 'react-redux';
import { createMaterialRequestAction } from '../../store/material/materialActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateMaterial = ({ createMaterialRequest, isLoading, createMaterialData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleMaterialSubmit = (materialData) => {
    createMaterialRequest({ data: materialData, navigate });
  };

  const handleBackToList = () => {
    navigate('/material');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/material" onClick={(e) => { e.preventDefault(); handleBackToList(); }}>
          {t('material')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createMaterial')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('createMaterial')}</h4>
            </CCardHeader>
            <CCardBody>
              <MaterialInputs
                onSubmit={handleMaterialSubmit}
                onCancel={handleBackToList}
                isLoading={isLoading}
                submitResponse={createMaterialData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  createMaterialData: state.materialReducer.createMaterialData,
  isLoading: state.loadingReducer.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createMaterialRequest: (payload) => dispatch(createMaterialRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateMaterial);
